import { H4 } from 'foundations-components/transitional/components/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
//@ts-expect-error Could not find declaration file for module
import tableImage from 'bender-url!../../../../images/table-two-rows.svg';
import { Image } from 'foundations-components/transitional/components/Image';
import { AssignPlaylistButton } from './AssignPlaylistButton';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentsBlankPage = ({
  playlistId,
  portalId
}) => {
  const {
    isDesktop,
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "start",
    flexDirection: isTablet ? 'column' : undefined,
    gap: isDesktop ? '1500' : '700',
    justifyContent: "space-between",
    paddingInline: isTablet ? '400' : '0',
    children: [/*#__PURE__*/_jsxs(View, {
      inlineSize: isTablet ? '100%' : '60%',
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistAssignments.blank.header"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistAssignments.blank.body"
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(AssignPlaylistButton, {
          playlistId: playlistId,
          portalId: portalId,
          use: "secondary"
        })
      })]
    }), /*#__PURE__*/_jsx(Image, {
      inlineSize: isTablet ? '100%' : '40%',
      src: tableImage
    })]
  });
};
export default PlaylistAssignmentsBlankPage;